var angular = require('angular');
require('../number-input');
var module =  angular.module("app.directives");

module.directive("legalStatusOptions", function ($timeout) {
  return {
    template: require("./index.pug"),
    replace:true,
    require: 'ngModel',
    scope: {
      options: "="
    },
    link: function (scope, el, attrs, ngModel) {
      scope.items = [];

      scope.$watch("options", function(options){
        if (!options || !options.length) {
          scope.items = [];
        }

        var model = ngModel.$viewValue || [];

        if(!scope.options) return;

        scope.items = angular.copy(scope.options).map(function(item, index){
          for (var i = 0; i < model.length; i++) {
            var mItem = model[i];
            if (mItem.id == item.id && mItem.checked) {
              item.checked = true;
              item.selectedStatusOptionId = mItem.selectedStatusOptionId;
              item.extraInformation = mItem.extraInformation;
              item.document = mItem.document;
              break;
            }
          }
          return item;
        })

      })

      scope.$watch("items", function(){
        ngModel.$setViewValue(scope.items)
      }, true)

      scope.statusChanged = function(orgType) {
        if (!orgType.checked) {
          orgType.extraInformation = "";
        }
      }

      scope.documentAdded = function(orgType) {
        var doc = orgType.document;
        orgType.document.blobId = doc.id;
      }
    },
  };
});
